import React, { useMemo, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import autoDiscovery from "../../Assets/Projects/auto_discovery.png";
import trtutorImg from "../../Assets/Projects/trtutor.png";
import monkey_brain from "../../Assets/Projects/monkey-mind-headspace.webp";
import light_bulb from "../../Assets/light_bulb.gif";
import umassRecwell from "../../Assets/Projects/umass_recwell.png";
import umassRideShare from "../../Assets/Projects/umass_ride_share.png";
import intermissionLite from "../../Assets/Projects/intermissionlite.png";
import careerMojoImg from "../../Assets/Projects/careermojo.png";
import yoursTrulyImg from "../../Assets/Projects/yours_truly.png";
import rlImg from "../../Assets/Projects/RL.png";
import sycophancyImg from "../../Assets/Projects/sycophancy.png";
import pyritImg from "../../Assets/Projects/pyrit.png";
import ragImg from "../../Assets/Projects/dragin.png";

const rankedProjects = [
  {
    id: "ai2-literature-grounding",
    imgPath: autoDiscovery,
    imgFit: "contain",
    title: "AI2 Research Externship: Literature Grounding for Scientific Discovery",
    description:
      "Exploring literature-grounding for an automated scientific discovery system: retrieving scientific papers and injecting evidence into multi-agent workflows for hypothesis generation and experiment selection.",
    ghLink: "https://github.com/allenai/autodiscovery",
    demoLink: "",
  },
  {
    id: "trtutor",
    imgPath: trtutorImg,
    imgFit: "contain",
    title: "TRTutor (Talker–Reasoner Tutor)",
    description:
      "Personalized math tutor with shared memory + async belief-state updates; LoRA fine-tuning on 10k+ persona-conditioned tutoring turns; improved personalization quality vs baseline (paper in progress).",
    ghLink: "https://github.com/vb-creator/TRtutor",
    demoLink: "",
  },
  {
    id: "musique-rl",
    imgPath: rlImg,
    imgFit: "contain",
    title: "MuSiQUE With RL: Example Selector for Multi-hop Reasoning",
    description:
      "Trained an RL-based example selector for multi-hop reasoning by framing selection as a decision process; observed +5% to +20% accuracy gains over a random baseline in experiments.",
    ghLink: "https://github.com/varshini2305/question_decomposition_using_rl",
    demoLink: "",
  },
  {
    id: "sycophane-mitigation",
    imgPath: sycophancyImg,
    imgFit: "contain",
    title: "The Curious Case of Sycophancy",
    description:
      "Built an end-to-end mitigation pipeline to localize sycophancy-causal heads via path patching; implemented Supervised Pinpoint Tuning (SPT) and achieved 87.1% truthfulness on SycophancyEval for LLaMA-2-13B (surpassing SFT).",
    ghLink: "",
    demoLabel: "Report",
    demoLink: "https://drive.google.com/file/d/1S7_sJn9VCq4eMCbiL9VFYwaiaax6aZVZ/view",
  },
  {
    id: "rag-overengineering",
    imgPath: ragImg,
    imgFit: "contain",
    title: "Overengineering in RAG: Robustness Study",
    description:
      "Analyzed 20+ recent RAG frameworks and 10+ widely-used baselines to assess robustness under model/dataset/context shifts, surfacing recurring generalization failures consistent with system-level overengineering.",
    ghLink: "",
    demoLink: "",
  },
  {
    id: "pyrit-redteam",
    imgPath: pyritImg,
    imgFit: "contain",
    title: "AI Red-Teaming (PyRIT Contributions)",
    description:
      "Contributed to PyRIT, improving Greedy Coordinate Gradient (GCG) adversarial attack performance and integrating new datasets.",
    ghLink: "https://github.com/Azure/PyRIT",
    demoLink: "",
  },
  {
    id: "careermojo",
    imgPath: careerMojoImg,
    imgFit: "contain",
    title: "CareerMojo",
    description:
      "Building a zero-to-one credibility-first dynamic talent portfolio + career-planning agent that structures evidence (projects/repos/writing) to assess technical and culture fit; running recruiter and job-seeker discovery interviews.",
    ghLink: "",
    demoLink: "https://careermojo.tech/",
  },
  {
    id: "yours-truly",
    imgPath: yoursTrulyImg,
    imgFit: "contain",
    title: "Yours Truly (IEEE Access Publication)",
    description:
      "Published credibility framework for LLM-powered fact-checking focused on practical trust signals and verification workflows.",
    ghLabel: "Paper",
    ghLink: "https://ieeexplore.ieee.org/document/10807167",
    demoLink: "",
  },
  {
    id: "luminosity-classifier",
    imgPath: light_bulb,
    title: "Luminosity Classifier",
    description: "Classify if a product catalog item is a lighting object.",
    ghLink: "https://github.com/varshini2305/luminosity_classifier",
    demoLink: "",
  },
  {
    id: "micromanage-me",
    imgPath: monkey_brain,
    title: "Micromanage Me",
    description:
      "Focus app that nudges one-page-at-a-time browsing to reduce context switching.",
    ghLink: "https://github.com/varshini2305/micromanage_me",
    demoLink: "",
  },
  {
    id: "umass-recwell",
    imgPath: umassRecwell,
    title: "UMass RecWell",
    description: "Search and discover group fitness classes at UMass RecWell.",
    ghLink: "https://github.com/varshini2305/recwell",
    demoLink: "",
  },
  {
    id: "umass-rideshare",
    imgPath: umassRideShare,
    title: "UMass Ride Share",
    description: "Match students sharing rides between Amherst and Boston/NYC.",
    ghLink: "https://github.com/varshini2305/umass-ride-share",
    demoLink: "",
  },
  {
    id: "intermissionlite",
    imgPath: intermissionLite,
    title: "IntermissionLite",
    description: "Minimal macOS app nudging scheduled eye breaks.",
    ghLink: "https://github.com/varshini2305/IntermissionLite",
    demoLink: "",
  },
];

const learningLoops = [
  {
    id: "ai",
    label: "NLP Research",
    subLabel:
      "Foundations of LLMs, Retrieval augmented Generation, Reinforcement Learning, Mechanistic interpretability, LLM Attacks and AI red-teaming",
  },
  {
    id: "systems",
    label: "Systems Research",
    subLabel: "Computer architecture & ML infra",
  },
  {
    id: "theory",
    label: "Algorithms & Fairness",
    subLabel: "Fair allocation, Game Theory, Mechanism Design",
  },
];

function Projects() {
  const [activeLoop, setActiveLoop] = useState(learningLoops[0].id);
  const loopDetails = useMemo(
    () => learningLoops.find((loop) => loop.id === activeLoop) ?? learningLoops[0],
    [activeLoop]
  );
  const loopSummary = loopDetails?.summary ?? loopDetails?.subLabel ?? "";
  const loopHighlights = loopDetails?.highlights ?? [];
  const loopFootnote = loopDetails?.footnote ?? "";

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Projects & Research Work</strong>
        </h1>
        <p style={{ color: "white" }}>
          Ranked by relevance and impact: most research-heavy AI work first.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {rankedProjects.map((project) => (
            <Col md={4} className="project-card" key={project.id}>
              <ProjectCard
                imgPath={project.imgPath}
                imgFit={project.imgFit}
                isBlog={false}
                ghLabel={project.ghLabel}
                demoLabel={project.demoLabel}
                title={project.title}
                description={project.description}
                ghLink={project.ghLink}
                demoLink={project.demoLink}
              />
            </Col>
          ))}
        </Row>

        <section className="projects-learning-section">
          <div className="section-heading">
            <h2>Actively learning</h2>
          </div>
          <div className="focus-tabs" role="tablist">
            {learningLoops.map((loop) => (
              <button
                type="button"
                key={loop.id}
                className={`focus-tab ${activeLoop === loop.id ? "active" : ""}`}
                onClick={() => setActiveLoop(loop.id)}
                role="tab"
                aria-selected={activeLoop === loop.id}
              >
                <span>{loop.label}</span>
                <small>{loop.subLabel}</small>
              </button>
            ))}
          </div>
          <div className="focus-panel">
            {loopSummary && <p>{loopSummary}</p>}
            {loopHighlights.length > 0 && (
              <ul>
                {loopHighlights.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
            {loopFootnote && <p className="footnote">{loopFootnote}</p>}
          </div>
        </section>
      </Container>
    </Container>
  );
}

export default Projects;
